import axios from 'axios'

$(document).ready(function () {
  $('.quantity-selector-up').on('click', function () {
    const input = $(this).prev()
    const current = Number(input.val())
    const selector = $(this).parent()

    if (selector.hasClass('cart-quantity')) {
      const key = selector.attr('data-key') // line item key
      const quantity = current + 1

      axios.post('/cart/change.js', { id: key, quantity }).then(() => {
        location.reload()
      })
    } else {
      input.val(current + 1)
    }
  })

  $('.quantity-selector-down').on('click', function () {
    const input = $(this).next()
    const current = Number(input.val())
    const selector = $(this).parent()

    if (current > 1) {
      if (selector.hasClass('cart-quantity')) {
        const key = selector.attr('data-key')
        const quantity = current - 1

        axios.post('/cart/change.js', { id: key, quantity }).then(() => {
          location.reload()
        })
      } else {
        input.val(current - 1)
      }
    }
  })
})
